import React from 'react';
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import BasicButton from "../../../../components/SharedComponents/BasicButton/BasicButton";
import BasicTextField from "../../../../components/SharedComponents/BasicTextField/BasicTextField";
import BasicCheckbox from "../../../../components/SharedComponents/BasicCheckbox/BasicCheckbox";
import CircularProgress from "@material-ui/core/CircularProgress";
import SelectField from "../../../../components/SharedComponents/SelectField/SelectField";
import SearchSelectField from "../../../../components/SharedComponents/SearchSelectField";
import BasicLabel from "../../../../components/SharedComponents/BasicLabel/BasicLabel";
import { initialCueSheetConfig,publisherConfig } from './Config';
import './SyncLicensor.scss';
import * as Constants from '../../../../constants/constants';
import ClearTrackService from '../../../../services/service';
import { withUserContext } from '../../../../contexts/UserContext';
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import EditCueSheetPublisherModal from './EditCueSheetPublisherModal';
import Popover from '@material-ui/core/Popover';
import NotificationComponent from "../../../../Common/NotificationComponent/NotificationComponent";
import messages from "../../../../Common/Messages.json"
import SearchFieldWithAddValue from '../../../../components/SharedComponents/SearchFieldWithAddValue'; 
import WarningNotesModal from '../../../SharedComponents/WarningNotesModal/WarningNotesModal';
import { checkEntityWarningNotes, closeWarningNotesModal, emptyWarningNotesModal } from '../../../../Common/warningNotesHelper';


class EditCueSheetPublisherInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            publisherOption: [],
            affiliationOption: [],
            cueSheetPublisherInfoDetails: this.formatPublisherList(JSON.parse(JSON.stringify({ ...initialCueSheetConfig }))),
            cueSheetPublisherRecord: this.formatPublisherList(JSON.parse(JSON.stringify({ ...initialCueSheetConfig }))),
            postInitiated: false,
            songId: null,
            licensorId:null,
            setModal: null,
            EditPublisherValue: null,
            EditPublisherName: null,
            showError: false,
            showSuccess: false,
            showFail: false,
            unsavedTitle: "Unsaved Changes",
            fieldChanged: false,
            failMessage: "Saving changes failed!",
            saveTitle: "Success",
            saveEditMessage: "The changes are saved successfully!",
            deletedCueSheets:[],
            displayErrorText:false,
            errorText:null,
            backupCueSheetPublishers: [],
            isMusicSupervisorEmail: false,
            isSendEmail: false,
            warningNotesModal: { ...emptyWarningNotesModal },
        };
    };

    showEntityWarningNotes = (entityKey, entityId, entityName, warningNotes) => {
        checkEntityWarningNotes(this, {
            entityKey,
            entityId,
            entityName,
            warningNotes,
            tenantId: this.props.userContext?.active_tenant?.tenant_id,
        });
    };

    componentDidMount() {
        this.getCueSheetDetails();
        this.getStaticData("affiliationOption", "lu_affiliation");
        this.getStaticData("publisherOption", "lu_cue_sheet_publisher");
        const divisionRoles = this.props?.userContext?.active_tenant?.division_role || [];
        const validRoles = ['Music Supervisor', 'Music Editor/Supervisor'];
        const isMusicSupervisorEmail = divisionRoles.every(role => validRoles.includes(role?.role_name));
        this.setState({ isMusicSupervisorEmail });
    }

    formatPublisherList = (response) => {
        if (response.cue_sheet_publishers?.length === 0) {
            response.cue_sheet_publishers.push(JSON.parse(JSON.stringify({ ...publisherConfig })))
            return response;
        }
    }

    getCueSheetDetails = () => {
    let data = JSON.parse(JSON.stringify(this.state.cueSheetPublisherInfoDetails));
    data.song_id = this.props.selectedSong?.song_id
    data.licensor_id = this.props.lic.licensor_id
    let songListObj=null, cueSheetSongsObj = null, songListObjKeys=null, cueSheetSongsObjKeys = null;
    if(this.props.lic.cue_sheet_publishers?.length > 0){
        data.cue_sheet_publishers = this.props?.lic?.cue_sheet_publishers?.filter(item => item[this.props?.isMainTitle ? 'main_title_licensor_id' : 'clearance_licensor_id'] === this.props?.selectedSong[this.props?.isMainTitle ? 'main_title_licensor_id' : 'clearance_licensor_id']);
        songListObj = (Object.groupBy(this.props?.lic?.songs, ({ song_id }) => song_id)); // get song_id by songs arr 
        cueSheetSongsObj = (Object.groupBy(this.props.lic.cue_sheet_publishers, ({ song_id }) => song_id)); // get existing song_id by existing cus_sheet_publishers
        songListObjKeys = Object.keys(songListObj);
        songListObjKeys=songListObjKeys.map(Number);
        cueSheetSongsObjKeys = Object.keys(cueSheetSongsObj);
        cueSheetSongsObjKeys=cueSheetSongsObjKeys.map(Number);
        this.props?.lic?.songs?.map((song, index) => {
            if(song?.song_id && !cueSheetSongsObjKeys.includes(song?.song_id)){
                let tempData = {};
                tempData[song?.song_id]=[{...publisherConfig}]
                tempData[song?.song_id][0]["song_id"]=song?.song_id;
                tempData[song?.song_id][0]["song_title"]=song?.song_title;
                // tempData[song?.song_id][0]["performer_id"]=song?.performer_id;
                tempData[song?.song_id][0]["performer_name"]=song?.performer_name;
                cueSheetSongsObj = { ...cueSheetSongsObj, ...tempData }
            }
        })
        data.cue_sheet_publishers_grouped = Object.values(cueSheetSongsObj);
        data.cue_sheet_publishers_grouped = data.cue_sheet_publishers_grouped.reverse();
    }else{
        data.cue_sheet_publishers = [],cueSheetSongsObj=[];
        this.props?.lic?.songs?.map((song, index) => {
            if(song?.song_id){
                cueSheetSongsObj?.push([{ ...publisherConfig }]);
                cueSheetSongsObj[index][0]["song_id"]=song?.song_id;
                cueSheetSongsObj[index][0]["song_title"]=song?.song_title;
                // cueSheetSongsObj[index][0]["performer_id"]=song?.performer_id;
                cueSheetSongsObj[index][0]["performer_name"]=song?.performer_name;
            }
        })
        data.cue_sheet_publishers_grouped = cueSheetSongsObj;
    }
    this.setState({
        cueSheetPublisherInfoDetails: data,
        backupCueSheetPublishers: JSON.parse(JSON.stringify(this.props?.lic?.cue_sheet_publishers || []))
    }, () => {
        this.setState({ cueSheetPublisherRecord: this.state.cueSheetPublisherInfoDetails })
    })
    }

    postSendDataEmail = (payload) => {
        const tenantId = this.props?.userContext?.active_tenant?.tenant_id;
        this.setState({ isSendEmail: true });
        ClearTrackService.postDataParams(`${Constants.ClearTrackServiceBaseUrl}/sendEmail`, payload, tenantId)
            .then(() => this.setState({ isSendEmail: false }))
            .catch(() => this.setState({ isSendEmail: false }));
    };

    getSongTitleForCueSheet = (publisher) => {
        if (publisher?.song_title) return publisher.song_title;

        const licSong = (this.props?.lic?.songs || []).find(song => song?.song_id === publisher?.song_id);
        if (licSong?.song_title) return licSong.song_title;

        const clearanceSong = (this.props?.licensorsInfo?.[0]?.songs_list || []).find(
            song => song?.song_id === publisher?.song_id
        );
        return clearanceSong?.song_title || '';
    };

    resolvePublisherSongId = (publisher) => {
        if (publisher?.song_id) return publisher.song_id;

        const publisherIdKey = this.props?.isMainTitle
            ? 'main_title_song_cue_sheet_publisher_id'
            : 'clearance_song_cue_sheet_publisher_id';
        const publisherId = publisher?.[publisherIdKey];

        if (publisherId != null) {
            const fromBackup = (this.state.backupCueSheetPublishers || []).find(
                item => item?.[publisherIdKey] === publisherId
            );
            if (fromBackup?.song_id) return fromBackup.song_id;
        }

        if (this.props?.selectedSong?.song_id) return this.props.selectedSong.song_id;

        return (this.props?.licensorsInfo?.[0]?.songs_list || [])[0]?.song_id || null;
    };

    getPublisherName = (publisher) => {
        if (publisher?.cue_sheet_publisher_name) return publisher.cue_sheet_publisher_name;

        const publisherIdKey = this.props?.isMainTitle
            ? 'main_title_song_cue_sheet_publisher_id'
            : 'clearance_song_cue_sheet_publisher_id';
        const backupPublisher = (this.state.backupCueSheetPublishers || []).find(
            item => item?.[publisherIdKey] === publisher?.[publisherIdKey]
        );
        return backupPublisher?.cue_sheet_publisher_name || '';
    };

    getPublishersForEmailTracking = (publishers, deletedCueSheets = []) => {
        const publisherIdKey = this.props?.isMainTitle
            ? 'main_title_song_cue_sheet_publisher_id'
            : 'clearance_song_cue_sheet_publisher_id';
        const mergedPublishers = [...(publishers || [])];

        (deletedCueSheets || []).forEach((deletedPublisher) => {
            const publisherId = deletedPublisher?.[publisherIdKey];
            if (publisherId == null) return;

            const alreadyIncluded = mergedPublishers.some(
                publisher => publisher?.[publisherIdKey] === publisherId
            );
            if (!alreadyIncluded) {
                mergedPublishers.push({
                    ...deletedPublisher,
                    is_delete: 1,
                    song_id: this.resolvePublisherSongId(deletedPublisher)
                });
            }
        });

        return mergedPublishers;
    };

    trackCueSheetPublisherChangesBySong = (publishers, deletedCueSheets = []) => {
        const publisherIdKey = this.props?.isMainTitle
            ? 'main_title_song_cue_sheet_publisher_id'
            : 'clearance_song_cue_sheet_publisher_id';
        const backupPublishers = this.state.backupCueSheetPublishers || [];
        const changesBySong = {};
        const licensorName = this.props?.lic?.licensor_name;
        const publishersToTrack = this.getPublishersForEmailTracking(publishers, deletedCueSheets);

        const ensureSongEntry = (publisher) => {
            const songId = this.resolvePublisherSongId(publisher);
            if (!songId) return null;
            if (!changesBySong[songId]) {
                changesBySong[songId] = {
                    song_title: this.getSongTitleForCueSheet({ ...publisher, song_id: songId }),
                    changes: []
                };
            }
            return changesBySong[songId];
        };

        (publishersToTrack || []).forEach((publisher) => {
            const publisherId = publisher?.[publisherIdKey];
            const songEntry = ensureSongEntry(publisher);
            if (!songEntry) return;

            if (publisher?.is_delete == 1) {
                if (publisherId != null) {
                    const existingPublisher = this.getPublisherName(publisher);
                    if (existingPublisher) {
                        songEntry.changes.push({
                            type: 'deleted',
                            existingPublisher,
                            licensorName,
                            field: 'Cue Sheet Publisher'
                        });
                    }
                }
                return;
            }

            if (publisherId == null) {
                if (publisher?.cue_sheet_publisher_name) {
                    songEntry.changes.push({
                        type: 'added',
                        newPublisher: publisher.cue_sheet_publisher_name,
                        licensorName,
                        field: 'Cue Sheet Publisher'
                    });
                }
                return;
            }

            const backupPublisher = backupPublishers.find(item => item?.[publisherIdKey] === publisherId);
            if (!backupPublisher) return;

            const isAttributesChanged = (
                Number(backupPublisher.share) !== Number(publisher.share) ||
                Number(backupPublisher.affiliation_id) !== Number(publisher.affiliation_id) ||
                Number(backupPublisher.is_active) !== Number(publisher.is_active)
            );
            const isPublisherChanged = String(backupPublisher.cue_sheet_publisher_name || '').trim() !==
                String(publisher.cue_sheet_publisher_name || '').trim();

            if (!isAttributesChanged && !isPublisherChanged) return;

            songEntry.changes.push({
                type: 'updated',
                licensorName,
                existingPublisher: backupPublisher.cue_sheet_publisher_name,
                newPublisher: publisher.cue_sheet_publisher_name,
                field: isAttributesChanged ? 'Cue Sheet Publisher Attributes' : 'Cue Sheet Publisher'
            });
        });

        return changesBySong;
    };

    sendCueSheetPublisherEmailNotifications = (publishers, deletedCueSheets = []) => {
        if (!this.state.isMusicSupervisorEmail) return;

        const changesBySong = this.trackCueSheetPublisherChangesBySong(publishers, deletedCueSheets);
        Object.values(changesBySong).forEach(({ song_title, changes }) => {
            if (!changes.length) return;

            this.postSendDataEmail({
                letter_type: "editSongDetailNotification",
                song_title,
                licensor_changes: [],
                performer_licensor_changes: [],
                writer_changes: [],
                performer_changes: [],
                cue_sheet_publisher_changes: changes,
                pd_composer_changes: []
            });
        });
    };

    getStaticData = (optionType, tableName) => {
        ClearTrackService.getData(Constants.ClearTrackServiceBaseUrl +
            `/staticData?staticTable=${tableName}`, this.props?.userContext?.active_tenant?.tenant_id)
            .then(response => {
                let list = [];
                if (tableName === "lu_affiliation") {
                    list = response?.data?.map(item => ({
                        label: item.name,
                        value: item.id,
                        is_active: item?.is_active,
                    }));
                } else if (tableName === "lu_cue_sheet_publisher") {
                    list = response?.data?.map(item => ({
                        text: item.name,
                        value: item.id,
                        warning_notes: item.warning_notes,
                    }));
                }
                this.setState({ [optionType]: list, publisherOptionCopy:tableName === "lu_cue_sheet_publisher" ? list : [] })
            })
    }

    getEntity = (entity, entityType, searchString) => {
        ClearTrackService.getData(Constants.ClearTrackServiceBaseUrl +
            `/entitySearch?entity=${entityType}&searchString=${searchString}`, this.props.userContext.active_tenant.tenant_id)
            .then(response => {
                if (entityType === "CUE_SHEET_PUBLISHER") {
                    let publishers = response?.data?.map(item => ({
                        text: item.cue_sheet_publisher_name,
                        value: item.cue_sheet_publisher_id,
                        warning_notes: item.warning_notes,
                    }));
                    this.setState({ [entity]: publishers })
                }
            })
    }

    handleChange = (field, value) => {
        if (field === "is_closed" ) {
            this.setState({
                cueSheetPublisherInfoDetails: {
                    ...this.state.cueSheetPublisherInfoDetails.cue_sheet_publishers,
                    [field]: value ? 1 : 0,
                },
            },()=>{this.setState({cueSheetPublisherRecord:this.state.cueSheetPublisherInfoDetails})});
        }
        else {
            this.setState(prevState => ({
                cueSheetPublisherInfoDetails: {
                    ...prevState.cueSheetPublisherInfoDetails,
                    [field]: value
                },
                postInitiated: false
            },()=>{ this.setState({cueSheetPublisherRecord:this.state.cueSheetPublisherInfoDetails})}), () => {
                this.props?.fieldChanged(true, "change");
            })
            
        }
       
    }
    
    removeRecord(index, clearanceOrMainTitleSongCueSheetPublisherId, parentIndex) {
        let data = JSON.parse(JSON.stringify(this.state.cueSheetPublisherInfoDetails)); //used for rendering
        let value = JSON.parse(JSON.stringify(this.state.cueSheetPublisherRecord)); //original record
        let deletedCueSheets=JSON.parse(JSON.stringify(this.state.deletedCueSheets));
        if(clearanceOrMainTitleSongCueSheetPublisherId != null){
            const deletedItem = JSON.parse(JSON.stringify(
                value?.cue_sheet_publishers_grouped?.[parentIndex]?.[index] ||
                value?.cue_sheet_publishers?.find(item =>
                    this.props?.isMainTitle
                        ? item.main_title_song_cue_sheet_publisher_id === clearanceOrMainTitleSongCueSheetPublisherId
                        : item.clearance_song_cue_sheet_publisher_id === clearanceOrMainTitleSongCueSheetPublisherId
                ) ||
                {}
            ));
            deletedItem.is_delete = 1;
            if (!deletedItem.song_id) {
                deletedItem.song_id = value?.cue_sheet_publishers_grouped?.[parentIndex]?.[0]?.song_id || null;
            }
            deletedCueSheets.push(deletedItem);

            value?.cue_sheet_publishers?.map((item) => {
                if(this.props?.isMainTitle ? item.main_title_song_cue_sheet_publisher_id === clearanceOrMainTitleSongCueSheetPublisherId : item.clearance_song_cue_sheet_publisher_id === clearanceOrMainTitleSongCueSheetPublisherId){
                    item['is_delete']= 1;
                }
            })
            data.cue_sheet_publishers.splice(index, 1);
            value?.cue_sheet_publishers_grouped[parentIndex]?.map((item) => {
                if(this.props?.isMainTitle ? item.main_title_song_cue_sheet_publisher_id === clearanceOrMainTitleSongCueSheetPublisherId : item.clearance_song_cue_sheet_publisher_id === clearanceOrMainTitleSongCueSheetPublisherId){
                    item['is_delete']= 1;
                }
            })
            data.cue_sheet_publishers_grouped[parentIndex].splice(index, 1);
        } else {
            // value.cue_sheet_publishers.splice(index, 1);  
            // value.cue_sheet_publishers_grouped[parentIndex].splice(index, 1);
            data.cue_sheet_publishers.splice(index, 1);
            data.cue_sheet_publishers_grouped[parentIndex].splice(index, 1)
        }
        
        this.setState({
            cueSheetPublisherInfoDetails: data, cueSheetPublisherRecord: value,deletedCueSheets
        })
        this.props?.fieldChanged(true, "change")
    }

    addRecord(index) {
        let data = JSON.parse(JSON.stringify(this.state.cueSheetPublisherInfoDetails));
        let publisherConfigTemp = JSON.parse(JSON.stringify({ ...publisherConfig }))
        if(this.props?.isMainTitle){
            delete publisherConfigTemp.clearance_song_cue_sheet_publisher_id;
            publisherConfigTemp.main_title_song_cue_sheet_publisher_id = null;
        } else {
            publisherConfigTemp.clearance_song_cue_sheet_publisher_id = null;
        }
        publisherConfigTemp.song_id = this.state.cueSheetPublisherInfoDetails?.cue_sheet_publishers_grouped[index]?.[0]?.song_id;
        data.cue_sheet_publishers.push(publisherConfigTemp);
        data.cue_sheet_publishers_grouped[index].push(publisherConfigTemp);
        this.setState({
            cueSheetPublisherInfoDetails: data
        },()=>{ this.setState({cueSheetPublisherRecord:this.state.cueSheetPublisherInfoDetails})})
        //this.props?.fieldChanged(true, "change")
    }
    validateFields = (data) => {
        if(data?.cue_sheet_publishers?.filter(item => (item.song_cue_sheet_publisher_id !== null && (item.cue_sheet_publisher_name === null && item.affiliation_id === null && item.share === null) && (item?.is_delete === undefined || item?.is_delete === null)))?.length >=1){
            //if any existing publisher record is cleared by dropdown Clear (X) button then the publisher will be assumed for deletion and it should be considered validRecord even if there is no publisher, affiliation or share added.
            this.setState({displayErrorText:false,errorText:null})
            return false;
        }else if(data?.cue_sheet_publishers?.filter(item => (item.song_cue_sheet_publisher_id === null && (item.cue_sheet_publisher_name !== null && (item.affiliation_id === null || item.share === null))))?.length >=1){
            //if publisher is selected but affiliation or share is not entered w.r.t that publisher then it should be considered invalid record and should show error message to enter affiliation and share details.
            this.setState({displayErrorText:true, errorText:"Please enter Affiliation and Share details for selected publisher(s)."})
            return false;
        }else if(data?.cue_sheet_publishers?.filter(item => (item.song_cue_sheet_publisher_id === null && (item.cue_sheet_publisher_name === null && (item.affiliation_id !== null || item.share !== null))))?.length >=1){
            //if affiliation or share is entered but publisher is not entered then it should be considered invalid record and should show error message to enter affiliation and share details.
            this.setState({displayErrorText:true, errorText:"Please select Publisher for the entered field(s)."})
            return false;
        }else{
            this.setState({displayErrorText:false,errorText:null})
            return true;
        }
    }
    handleSubmit = () => {
        this.setState({ postInitiated: true })
        let postData = JSON.parse(JSON.stringify(this.state.cueSheetPublisherRecord));
        postData.cue_sheet_publishers = postData.cue_sheet_publishers_grouped.flat(2);
        delete postData.cue_sheet_publishers_grouped;
        if (!this.validateFields(postData)){
            return;
        }
        for(let i = postData.cue_sheet_publishers?.length-1; i>=0; i--){
            if(postData.cue_sheet_publishers?.[i]?.cue_sheet_publisher_name===null && postData.cue_sheet_publishers?.[i]?.affiliation_id===null && postData.cue_sheet_publishers?.[i]?.share===null ){
                postData.cue_sheet_publishers.splice(i,1)
            }
        }
        if(this.state.deletedCueSheets?.length>0){
            const arr1Ids = new Set(postData?.cue_sheet_publishers?.map(x => this.props?.isMainTitle? x.main_title_song_cue_sheet_publisher_id : x.clearance_song_cue_sheet_publisher_id));
            const cueSheetToDelete = this.state.deletedCueSheets?.filter(
            item => !arr1Ids.has(this.props?.isMainTitle? item.main_title_song_cue_sheet_publisher_id : item.clearance_song_cue_sheet_publisher_id)
            );
            if(cueSheetToDelete?.length>0){
                postData.cue_sheet_publishers?.push(cueSheetToDelete)
            }
        }
        postData.cue_sheet_publishers = postData.cue_sheet_publishers.flat(2);
        if(this.props?.isMainTitle){
            postData.main_title_id = this.props?.main_title_id ? this.props?.main_title_id  :null;
        }else{
            postData.clearance_id = this.props?.clearenceId ? this.props?.clearenceId  :null;
        }
        
        // postData.cue_sheet_publishers[this.state.cueSheetpublisherIndex]['cue_sheet_publisher_id']=this.state.cueSheetPublisherRecord.cue_sheet_publishers.find((item) => item.is_licensor === 1) ? this.props?.lic?.licensor_id : this.state.cueSheetPublisherInfoDetails.cue_sheet_publishers.cue_sheet_publisher_id;
        postData.song_id = this.props.selectedSong?.song_id // this.props.licensorsInfo?.[0]?.songs_list[0]?.song_id;
        postData.licensor_id = this.props?.lic?.licensor_id,
        this.setState({ isPosting: true })
        ClearTrackService.postDataParams(Constants.ClearTrackServiceBaseUrl +
            `/clearanceLicensorsCueSheetPublishers`, postData, this.props.userContext?.active_tenant?.tenant_id, this.props?.divisionId)
            .then(response => {
                if (response) {
                    if (response.data.error) {
                        this.setState({ isPosting: false,postInitiated:false })
                        this.props?.notificationComponent(true, 'fail')
                    } else {
                        this.sendCueSheetPublisherEmailNotifications(
                            postData.cue_sheet_publishers,
                            this.state.deletedCueSheets
                        );
                        this.props?.toggleRefreshCueSheetPublisherDetails();
                        this.setState({
                            isPosting: false,
                            postInitiated: false,
                            deletedCueSheets: [],
                            backupCueSheetPublishers: JSON.parse(JSON.stringify(
                                (postData.cue_sheet_publishers || []).filter(publisher => publisher?.is_delete !== 1)
                            ))
                        })
                        this.props?.notificationComponent(true, 'success')
                    }
                }
            })
        
    }

    notificationComponent = (value, mode = "fail") => {
        switch (mode) {
            case "success": return this.setState({ showSuccessMessage: value });
            case "fail": return this.setState({ showFailMessage: value });
        }
    }

    handleResetNotify = () => {
        this.setState({ showFailMessage: false, showSuccessMessage: false });
        if (this.state.saveFlag) {
          this.closeToastMessage();
        }
      }
      closeToastMessage = () => {
        this.setState({ showErrorMessage: false, showFailMessage: false, showSuccessMessage: false });
        if (this.state.saveFlag) {
          this.props?.handleClose();
        }
    }

    handleOnChange = (fieldArray, field, value, index, type = null, parentIndex) => {
        let publishers =JSON.parse(JSON.stringify(this.state.cueSheetPublisherInfoDetails));
        let deletedCueSheets = JSON.parse(JSON.stringify(this.state.deletedCueSheets)); 
        if (field === "cue_sheet_publisher" && type === 'update') {
            publishers.cue_sheet_publishers_grouped[parentIndex][index]["cue_sheet_publisher_id"] = value?.value || null;
            publishers.cue_sheet_publishers_grouped[parentIndex][index]["cue_sheet_publisher_name"] = value?.text || null;
            delete publishers.cue_sheet_publishers_grouped[parentIndex][index]['is_delete'];
            if (value?.value) {
                this.showEntityWarningNotes('cueSheetPublisher', value.value, value.text, value.warning_notes);
            }
        } else if (field === "cue_sheet_publisher" && value === null) {
            const deletedItem = JSON.parse(JSON.stringify(publishers.cue_sheet_publishers_grouped[parentIndex][index]));
            deletedItem.is_delete = 1;
            deletedCueSheets.push(deletedItem);
            //publishers.cue_sheet_publishers_grouped[parentIndex][index]['cue_sheet_publisher_id'] = null
            publishers.cue_sheet_publishers_grouped[parentIndex][index]['cue_sheet_publisher_name'] = null
            publishers.cue_sheet_publishers_grouped[parentIndex][index]['affiliation_id'] = null
            publishers.cue_sheet_publishers_grouped[parentIndex][index]['affiliation_name'] = null
            publishers.cue_sheet_publishers_grouped[parentIndex][index]['share'] = null
            publishers.cue_sheet_publishers_grouped[parentIndex][index]['is_licensor'] = null
            publishers.cue_sheet_publishers_grouped[parentIndex][index]['is_active'] = 1
            publishers.cue_sheet_publishers_grouped[parentIndex][index]['is_delete'] = 1
        } else if (field === "cue_sheet_publisher" && value?.optionType == 'new') {
            this.postPublisher(value?.value, index, parentIndex)
        } else if (field === "cue_sheet_publisher") {
            publishers.cue_sheet_publishers_grouped[parentIndex][index][field + '_id'] = value?.value || null;
            publishers.cue_sheet_publishers_grouped[parentIndex][index][field + '_name'] = value?.text || null;
            if(!this.props?.isMainTitle && (publishers.cue_sheet_publishers_grouped[parentIndex][index]?.clearance_song_cue_sheet_publisher_id||publishers.cue_sheet_publishers_grouped[parentIndex][index]?.clearance_song_cue_sheet_publisher_id===null)){
                delete publishers.cue_sheet_publishers_grouped[parentIndex][index]['is_delete'];
            }
            if(this.props?.isMainTitle && (publishers.cue_sheet_publishers_grouped[parentIndex][index]?.main_title_song_cue_sheet_publisher_id || publishers.cue_sheet_publishers_grouped[parentIndex][index]?.main_title_song_cue_sheet_publisher_id===null)){
                delete publishers.cue_sheet_publishers_grouped[parentIndex][index]['is_delete'];
            }
            if (value?.value) {
                this.showEntityWarningNotes('cueSheetPublisher', value.value, value.text, value.warning_notes);
            }
        }else if (field === "affiliation_id") {
            publishers.cue_sheet_publishers_grouped[parentIndex][index]['affiliation_id'] = value || null;
            publishers.cue_sheet_publishers_grouped[parentIndex][index]['affiliation_name'] = value?.text || null;
        }
        else if (field === "is_closed") {
            publishers.cue_sheet_publishers_grouped[parentIndex][index][field] = value ? 1 : 0 || null;
            publishers.cue_sheet_publishers_grouped[parentIndex][index]['cue_sheet_publisher_id'] = this.props?.lic?.licensor_id || null;
            publishers.cue_sheet_publishers_grouped[parentIndex][index]['cue_sheet_publisher_name'] = this.props?.lic?.licensor_name || null;
        }
        else if(field === "is_licensor"){
            publishers.cue_sheet_publishers_grouped[parentIndex][index][field] = value ? 1 : 0 || null;
            if(value){
                let isExist =  this.state?.publisherOption?.findIndex(x=>x.text == this.props?.lic?.licensor_name);
                if(isExist != -1){
                    publishers.cue_sheet_publishers_grouped[parentIndex][index]['cue_sheet_publisher_id'] = this.state?.publisherOptionCopy?.[isExist]?.value || null;
                    publishers.cue_sheet_publishers_grouped[parentIndex][index]['cue_sheet_publisher_name'] = this.state?.publisherOptionCopy?.[isExist]?.text || null;
                }
                else {
                    this.postPublisher(this.props?.lic?.licensor_name,index, parentIndex);
                }
            }
           else{
                    publishers.cue_sheet_publishers_grouped[parentIndex][index]['cue_sheet_publisher_id'] = null;
                    publishers.cue_sheet_publishers_grouped[parentIndex][index]['cue_sheet_publisher_name'] = null;
           }
        }  else if(field === "is_active")  {
          publishers.cue_sheet_publishers_grouped[parentIndex][index][field] = value;
        }    
        else {
            publishers.cue_sheet_publishers_grouped[parentIndex][index][field] = value || null;
        }
            this.setState({
            cueSheetPublisherInfoDetails: publishers,
            postInitiated: false,
            deletedCueSheets,
            displayErrorText:false,errorText:null
            }, () => {
            this.setState({ cueSheetPublisherRecord:this.state.cueSheetPublisherInfoDetails, publisherOption: [] })
            })
        
    };
    postPublisher(licensorName,index,parentIndex=null){
        let cuesheetPublisherData = { id:null,name:licensorName, is_active: 1, table_name: "lu_cue_sheet_publisher" };
        ClearTrackService.postDataParams(Constants.ClearTrackServiceBaseUrl + `/staticData`,
        cuesheetPublisherData,
        this.props?.userContext?.active_tenant?.tenant_id)
        .then(
            (response) => {
                if (response.data.error) {
                    this.props?.notificationComponent(true, 'fail')
                    // this.setState({ showLoading: false})
                } else {                  
                    // this.props.notificationComponent(true, "success");
                    let publishers =JSON.parse(JSON.stringify(this.state.cueSheetPublisherInfoDetails));
                    // publishers.cue_sheet_publishers[index]['cue_sheet_publisher_id'] = response.data?.[0]?.id || null;
                    // publishers.cue_sheet_publishers[index]['cue_sheet_publisher_name'] = licensorName || null;
                    publishers.cue_sheet_publishers_grouped[parentIndex][index]['cue_sheet_publisher_id'] = response.data?.[0]?.id || null;
                    publishers.cue_sheet_publishers_grouped[parentIndex][index]['cue_sheet_publisher_name'] = licensorName || null;
                    this.setState({
                        cueSheetPublisherInfoDetails: publishers,
                        postInitiated: false,
                    }, () => {
                        this.setState({ cueSheetPublisherRecord:this.state.cueSheetPublisherInfoDetails, publisherOption: [] })
                    })
                }
               
            },
            (err) => {
                
                this.props?.notificationComponent(true, 'fail')
            }
        )

    }
    handleClickModal = (event, index, parentIndex) => {
        let cueSheetPublisherInfoDetails = JSON.parse(JSON.stringify(this.state.cueSheetPublisherInfoDetails));
        // cueSheetPublisherInfoDetails.cue_sheet_publishers[index]['is_editing'] = true;
        cueSheetPublisherInfoDetails.cue_sheet_publishers_grouped[parentIndex][index]['is_editing'] = true;
        this.setState({
            setModal: event.currentTarget,
            cueSheetPublisherInfoDetails: cueSheetPublisherInfoDetails,
            parentIndex:parentIndex,
            childIndex:index
        })
    };

    handleCloseModal = () => {
        let cueSheetPublisherInfoDetails = JSON.parse(JSON.stringify(this.state.cueSheetPublisherInfoDetails));
        cueSheetPublisherInfoDetails.cue_sheet_publishers_grouped?.map(item => {
            item?.map((item2)=>{
               item2['is_editing'] = false;
               return item2;
            })
            
        })
        this.setState({
            setModal: null,
            cueSheetPublisherInfoDetails: cueSheetPublisherInfoDetails
        })
    };

    render() {
        const cueSheetPublisherCommonPermissions = this.props?.userContext?.active_tenant?.common_permissions?.find(item => item?.permission_name === "Cue Sheet Publishers tab")
        const roleName = this.props?.userContext?.active_tenant?.division_role?.find(item => item?.division_id === this.props?.divisionId)?.role_name;
        const isClearanceRegBasic = roleName === "Music Clearance (Regular User)" || roleName === "Music Clearance (Basic)";
        let openModal = Boolean(this.state.setModal);
        let idModal = open ? 'modal-popover' : undefined;
        let severity = this.state.showFailMessage ? "error" : this.state.showSuccessMessage ? "success" : "";
        let messageNotification = this.state.showSuccessMessage ? "Saved Changes Successfully" : this.state.showFailMessage ? "Saved Changes Failed" : "";
        //success modal popup
        let message = this.state.showFail ? this.state.failMessage :
        this.state.showSuccess ? this.state.saveEditMessage : null
        let comfirmModalTitle = this.state.showError ? this.state.unsavedTitle : this.state.showFail ? this.state.failMessage :
        this.state.showSuccess ? this.state.saveTitle : "";
        return (
            <MDBContainer className='editCueSheetPublisherInfo'>
                <NotificationComponent 
                    open={this.state.showSuccessMessage || this.state.showFailMessage} 
                    message={messageNotification} 
                    severity={severity}
                    handleResetNotify={this.handleResetNotify.bind(this)} 
                />
                {this.state?.displayErrorText && <p className="errorMsg">{this.state?.errorText}</p>}
                {this.state.cueSheetPublisherInfoDetails?.cue_sheet_publishers_grouped?.map((publishersGrouped, index2) => (
                    <>
                    {publishersGrouped?.length>0 && publishersGrouped?.map((publishers,index)=>{
                        return (<>
                        <MDBRow className="small-font">
                            {index===0 && <span className='f7'> The song[s] {publishers?.song_title} {publishers?.performer_name ? `by ${publishers?.performer_name}`:``}</span>}
                        </MDBRow>
                        {index===0 && <MDBRow>
                            <MDBCol md={5}>
                                    <BasicLabel 
                                        text="Publisher Name" 
                                        // isMandatory={true}
                                    />
                                </MDBCol>
                                <MDBCol md={1}></MDBCol>
                                <MDBCol md={3}>
                                    <BasicLabel 
                                        text="Affiliation" 
                                        // isMandatory={true}
                                    />
                                </MDBCol>
                                <MDBCol md={2}>
                                    <BasicLabel 
                                        text="Share" 
                                        //isMandatory={true}
                                    />
                                </MDBCol>
                            </MDBRow>
                        }
                          <MDBRow key={'publisher' + index2+index}>
                            <MDBCol md={5} id="Publisher">
                                {/* {publishers.is_licensor === 1 ? 
                                    <BasicLabel 
                                        text={this.props?.lic?.licensor_name} 
                                    /> : */}
                                    <>
                                        <SearchFieldWithAddValue
                                            // disabled={this.props?.isMainTitle && publishers?.main_title_song_cue_sheet_publisher_id ? true : !this.props?.isMainTitle && publishers?.clearance_song_cue_sheet_publisher_id ? true : false}
                                            id={"publisher-select"+index2+index}
                                            options={this.state.publisherOption?.filter(opt => 
                                                        !publishersGrouped?.some(pub => pub.cue_sheet_publisher_id === opt.value)
                                                        )}
                                            placeholder={"- Search -"}
                                            isMandatory={true}
                                            showMandatory={this.state.postInitiated}
                                            mandatoryWarning={messages.mandatoryWarning}
                                            detail_selected={ publishers.cue_sheet_publisher_name }
                                            onChange={(e, value) => this.handleOnChange('publishers', 'cue_sheet_publisher', value, index,null,index2)}
                                            searchText={(e, value) => {
                                                if (e.target.value !== "" || e.target.value !== null) {
                                                    this.getEntity('publisherOption',"CUE_SHEET_PUBLISHER",e.target.value)
                                                    }
                                            }}
                                            searchSelect={true}
                                            newLabel={'Publisher'}
                                            // loading={this.state.loading}
                                        />
                                    </>
                                {/* } */}
                            </MDBCol>
                            <MDBCol 
                                key={'edit-publisher' + index2+index} 
                                md={1} 
                                className='pen-btn'
                                id={'pen-btn' + index2+index} 
                                disabled={publishers.cue_sheet_publisher_id !== null && publishers.cue_sheet_publisher_name !== null ? false : true}
                            >
                                <BasicButton
                                    className={"pen-btn"}
                                    variant="contained"
                                    text=" "
                                    icon={"pen"}
                                    onClick={(e) => {!isClearanceRegBasic && this.handleClickModal(e, index, index2)}}
                                    disabled={cueSheetPublisherCommonPermissions?.edit == 0 || isClearanceRegBasic}
                                />
                            </MDBCol>
                            <MDBCol md={3} id="Affiliation">
                                <SelectField
                                    // label={`${index === 0 ? "Affiliation" : ""}`}
                                    // isMandatory={true}
                                    // showMandatory={this.state.postInitiated}
                                    // mandatoryWarning={messages.mandatoryWarning}
                                    placeHolderText={"- Select - "}
                                    value={publishers.affiliation_id || null}
                                    options={this.state.affiliationOption?.filter(item => item?.is_active === 1 || item?.value == publishers.affiliation_id) || []}
                                    onChange={(e, value) => this.handleOnChange('publishers', 'affiliation_id', e.target.value, index,null,index2)} />
                            </MDBCol>
                            <MDBCol md={2}>
                                <BasicTextField
                                    // label={`${index === 0 ? "Share" : ""}`}
                                    // isMandatory={true}
                                    // showMandatory={this.state.postInitiated}
                                    mandatoryWarning={messages.mandatoryWarning}
                                    value={publishers.share}
                                    onChange={(e, value) => this.handleOnChange('publishers', 'share', e.target.value, index,null,index2)} />
                            </MDBCol>
                            <MDBCol md={1}
                            >
                                <div className="add-remove-icons">
                                    <div>
                                        {!(publishersGrouped.length === 1)
                                            ? <RemoveCircleIcon fontSize="small" onClick={() => this.removeRecord(index, this.props?.isMainTitle ? publishers?.main_title_song_cue_sheet_publisher_id : publishers?.clearance_song_cue_sheet_publisher_id ,index2)} />
                                            : null
                                        }
                                    </div>
                                    <div className="ml5">
                                        {publishersGrouped.length- 1 === index && (publishers.cue_sheet_publisher_id != null || publishers.cue_sheet_publisher_name != null || publishers.cue_sheet_publisher_name != "") ?
                                            <AddCircleIcon fontSize="small" onClick={() => this.addRecord(index2)} />
                                            : null
                                        }
                                    </div>
                                </div>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow className='mt-2'>
                            <MDBCol md={9}>
                                <BasicCheckbox
                                    label="Cue Sheet Publisher name is same as Licensor"
                                    id={"-publisher_name"+index2+index}
                                    disabled={this.props.disabled || false}
                                    checked={publishers?.is_licensor}
                                    onChange={(e, value) => this.handleOnChange('publishers', 'is_licensor', e.target.checked, index,null,index2)} />
                            </MDBCol>
                            <MDBCol md={3}>
                                <BasicCheckbox
                                    label="Inactive"
                                    id={"Inactive-"+index2+index}
                                    disabled={this.props.disabled || false}
                                    checked={!publishers?.is_active}
                                    onChange={(e, value) => this.handleOnChange('publishers', 'is_active', e.target.checked?0:1, index,null,index2)} 
                                    align="end" />
                            </MDBCol>
                        </MDBRow>
                        </>)
                    })}
                    </>
                ))} 
                {/* {this.state.cueSheetPublisherInfoDetails?.cue_sheet_publishers?.map((publishers, index) => (
                        <>
                        
                    </>
                ))}  */}
                <MDBRow>
                    <MDBCol md={8}></MDBCol>
                    <MDBCol md={4}>
                        <MDBRow>
                            <MDBCol>
                                <BasicButton 
                                    text={this.state.isPosting ? <CircularProgress color="inherit" size={18} /> : "Save"}
                                    onClick={this.handleSubmit} 
                                />
                            </MDBCol>
                            <MDBCol>
                                <BasicButton onClick={() => this.props?.handleClose()} variant="outlined" text={"Cancel"} />
                            </MDBCol>
                        </MDBRow>
                    </MDBCol>
                </MDBRow>
                <Popover
                                    id={idModal}
                                    open={openModal}
                                    className={"pop-over"}
                                    anchorEl={this.state.setModal}
                                    onClose={this.handleCloseModal}
                                    anchorReference="anchorOrigin"
                                    anchorOrigin={{
                                        horizontal: "right",
                                        vertical: "bottom "
                                    }}
                                    transformOrigin={{
                                        horizontal: "left",
                                        vertical: "top"
                                    }}
                                    PaperProps={{ style: { width: '16%', backgroundColor: '#e6e6e6' } }}
                                    anchorPosition={{ top: 700, left: 300 }}
                                >
                                    <EditCueSheetPublisherModal 
                                        notificationComponent={this.notificationComponent}
                                        handleOnChange={this.handleOnChange}
                                        handleCloseModal={this.handleCloseModal}
                                        cueSheetPublisherInfoDetails={this.state.cueSheetPublisherInfoDetails}
                                        index={this.state.childIndex}
                                        index2={this.state.parentIndex}
                                    />
                                </Popover>
                {this.state.warningNotesModal?.open &&
                    <WarningNotesModal
                        {...this.state.warningNotesModal}
                        onConfirm={() => closeWarningNotesModal(this)}
                        handleClose={() => closeWarningNotesModal(this)}
                    />
                }
            </MDBContainer>
        )
    }
}

export default withUserContext(EditCueSheetPublisherInfo);
